import React, { createContext, useContext, useState } from "react";

export type UiLang = "es" | "en";

interface UiLangContextValue {
  uiLang: UiLang;
  toggleUiLang: () => void;
}

const UiLangContext = createContext<UiLangContextValue>({
  uiLang: "es",
  toggleUiLang: () => {},
});

export const UiLangProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [uiLang, setUiLang] = useState<UiLang>(() => {
    return (localStorage.getItem("ui-lang") as UiLang) || "es";
  });

  const toggleUiLang = () => {
    const next: UiLang = uiLang === "es" ? "en" : "es";
    setUiLang(next);
    localStorage.setItem("ui-lang", next);
  };

  return (
    <UiLangContext.Provider value={{ uiLang, toggleUiLang }}>
      {children}
    </UiLangContext.Provider>
  );
};

export const useUiLang = () => useContext(UiLangContext);
